// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'

import 'bootstrap'

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'

import 'react-toastify/dist/ReactToastify.css'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import paginationSelect from '../src/main/pagination_select'
paginationSelect()

// 一番上の名前空間
window.EL = window.EL || {}

// 共通
window.EL.Shared = window.EL.Shared || {}

import videoPlayer from '../src/main/video_player'
window.EL.Shared.VideoPlayer = window.EL.Shared.VideoPlayer || {}
window.EL.Shared.VideoPlayer = videoPlayer

import videoUploader from '../src/main/video_uploader'
window.EL.Shared.VideoUploader = window.EL.Shared.VideoUploader || {}
window.EL.Shared.VideoUploader = videoUploader

import pdfUploader from '../src/main/pdf_uploader'
window.EL.Shared.PdfUploader = window.EL.Shared.PdfUploader || {}
window.EL.Shared.PdfUploader = pdfUploader

import bulkCheck from '../src/main/bulk_check'
window.EL.Shared.BulkCheck = window.EL.Shared.BulkCheck || {}
window.EL.Shared.BulkCheck = bulkCheck
